<template>
    <div>
        <Navbar></Navbar>
        <slot></slot>
    </div>
</template>
<script>
import Navbar from "@landing/Layout/Navbar";

export default {
    components: { Navbar },
};
</script>
